import {
    SET_MARKERS,
    ADD_MARKER,
    REMOVE_MARKER
} from './Types';
import { IMarkerAction, IMarkersReducerState, Marker } from './markersTypes';

const defaultState: Marker[] = [
    /*
    {
        id: number,
        name: string,
        location: {
            lng: number,
            lat: number
        }
    }
    */
];

const reducer = (state: IMarkersReducerState = defaultState, action: IMarkerAction) => {
    switch (action.type) {
        case SET_MARKERS:
            return [
                ...action.markers
            ];
        case ADD_MARKER:
            return [
                ...state,
                action.marker
            ];
        case REMOVE_MARKER:
            return [
                ...state.filter(m => m.id !== action.id)
            ];
        default:
            return state;
    }
};

export default reducer;